import api from '../redux/httpUtil/ServerApi';

let utils = {
  baseUrl: api.baseUrl,
  serverUrl: window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')),
  getErrorInfo: (action) => {
    const { response = {} } = action;
    let { message } = response;
    let errorMessage = message === 'Failed to fetch' ? 'Please check your network connection' : message;
    return errorMessage;
  },

  downloadFile(pdfBase64, FileType, prefix) {

    var d = new Date();
    let Timestamp = (d.getMonth() + 1) + '' + d.getDate() + '' + d.getFullYear() + '' + d.getHours() + '' + d.getMinutes() + '' + d.getSeconds();

    let fileName = prefix + Timestamp + '.' + FileType;

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(pdfBase64);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: 'application/' + FileType
      });
      window.navigator.msSaveOrOpenBlob(blob, fileName);
      return;
    }

    // For Other Browsers than IE
    const linkSource = 'data:application/' + FileType + ';base64,' + pdfBase64;
    const link = document.createElement('a');
    link.href = linkSource;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.addEventListener("focus", function () {
      URL.revokeObjectURL(link.href);
    }, {
      once: true
    });
  }
}

export default utils;